    <p-accordion class="drawers-anchor"
                 [expandIcon]="'action glyphicon glyphicon-chevron-down'"
                 [collapseIcon]="'action glyphicon glyphicon-chevron-up'"
                 (onOpen)="onTabToggle($event, true)"
                 (onClose)="onTabToggle($event)"
    >
        <p-accordionTab *ngFor="let tab of tabContent; trackBy: trackByFn"
                        [header]="getDrawerName(tab)"
                        [selected]="loadedTabs.has(tab.formId)"
                        (selectedChange)="selectedChange($event, tab.formId)"
                        [ngClass]="{'selected-accordion-tab': selectedTabId[tab.formId]}"
        >
            <ng-container *ngIf="tabsData[tab.formId] ? loadedTabs.has(tab.formId) : false">
                <gen-dynamic-form
                        [formData]="tabsData[tab.formId]"
                        [disabled]="true"
                        [formName]="tab.formId"
                        [formItemFullWidth]="tab.formFullWidth"
                        [additionalSearchValues]="additionalSearchValues"
                        [editMode]="true"
                        (formChange)="tabCommunicates($event)">
                </gen-dynamic-form>
            </ng-container>
        </p-accordionTab>
    </p-accordion>
